import { render, staticRenderFns } from "./IndexRecurrencesPage.vue?vue&type=template&id=0c279164&"
import script from "./IndexRecurrencesPage.vue?vue&type=script&lang=js&"
export * from "./IndexRecurrencesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports